import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { advertismentCommand } from '../../model/const/command';
import { LettingAdvertismentService } from '../letting-advertisment.service';
import { LettingAdvertismentPlatformType } from '../../model/const/enums';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { SetHomeqOfficesFormComponent } from '../../../rent/component/set-homeq-offices-form/set-homeq-offices-form.component';
import { MessageService } from '../../../core/service/message.service';

@Injectable()
export class SendToPlatformCommandHandler implements ICommandHandler {
  constructor(
    private _advertService: LettingAdvertismentService,
    private _actionService: ActionWindowService,
    private _injector: Injector,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      if (command.context.isNew) {
        this._messageService.showError('LETTING.ADVERTISMENT.SEND_WARNING');
        return false;
      }
      return command.id === advertismentCommand.sendToPlatform && command.context;
    }
    return false;
  }

  execute(command: Command) {
    if (command instanceof Command) {
      if (command.context.platform === LettingAdvertismentPlatformType.HomeQ) {
        if (command.context.homeQOffice.id) {
          return this._advertService.sendToPlatform(command.context.id, command.context.homeQOffice.id);
        }
        return this._actionService.open(SetHomeqOfficesFormComponent, this._injector, null, command.context);
      } else {
        return this._advertService.sendToPlatform(command.context.id);
      }
    }
  }
}
